import script from "./cardTransactions.vue?vue&type=script&setup=true&lang=js"
export * from "./cardTransactions.vue?vue&type=script&setup=true&lang=js"

import "./cardTransactions.vue?vue&type=style&index=0&id=f1d48a76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1d48a76"]])

export default __exports__